import { render, staticRenderFns } from "./RELPrevistoRealizado.vue?vue&type=template&id=7b16c450&"
import script from "./RELPrevistoRealizado.vue?vue&type=script&lang=js&"
export * from "./RELPrevistoRealizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports